import type { RealtimeContentHint } from './types'


/**
 * @brief 实时媒体流的默认最大编码码率。
 * 单位为 Kbps；RTC 会根据网络和设备状态在该上限内动态调整实际发送码率。
 */
export const DEFAULT_REALTIME_STREAM_MAX_KBPS = 1200

export const DEFAULT_MOBILE_REALTIME_STREAM_MAX_KBPS = 3000


/**
 * @brief 实时媒体流的默认视频内容类型。
 * `detail` 表示优先保留图片、文字和复杂纹理的画面细节。
 */
export const DEFAULT_REALTIME_STREAM_CONTENT_HINT: RealtimeContentHint = 'detail'


/** 实时会话的默认心跳间隔，单位为 ms。 */
export const DEFAULT_REALTIME_HEARTBEAT_INTERVAL_MS = 10_000


/** 读取外部 MediaStream 视频元数据的默认等待时间，单位为 ms。 */
export const DEFAULT_METADATA_TIMEOUT_MS = 1000


/** 实时连接完成后默认立即开始生成。 */
export const DEFAULT_REALTIME_AUTO_START = true


/** Start 事件使用的默认内部模型名称。 */
export const DEFAULT_REALTIME_START_EVENT_MODEL = 'default'


/** SDK 托管媒体的默认播放设置。 */
export const DEFAULT_REALTIME_PLAYBACK_SETTING = {
  playbackRate: 1,
}


/** SDK 托管视图和拖拽交互的默认设置。 */
export const DEFAULT_REALTIME_RENDER_SETTING = {
  mirror: false,
  dragEnabled: true,
}


/**
 * @brief SDK 托管摄像头实时连接的环境默认设置。
 * 桌面端使用 `1472 × 832 @ 24fps`，移动端使用 `960 × 1280 @ 24fps`。
 */
export const DEFAULT_CAMERA_REALTIME_SETTINGS = {
  desktop: {
    width: 1472,
    height: 832,
    fps: 24,
    maxKbps: DEFAULT_REALTIME_STREAM_MAX_KBPS,
    contentHint: DEFAULT_REALTIME_STREAM_CONTENT_HINT,
  },
  mobile: {
    width: 960,
    height: 1280,
    fps: 24,
    maxKbps: DEFAULT_MOBILE_REALTIME_STREAM_MAX_KBPS,
    contentHint: DEFAULT_REALTIME_STREAM_CONTENT_HINT,
  },
}
